'use strict';

exports.__esModule = true;
exports.SelectButton = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SelectButton = exports.SelectButton = function SelectButton(props) {
  var open = props.open,
      listId = props.listId,
      buttonId = props.buttonId,
      highlightedId = props.highlightedId,
      onKeyDown = props.onKeyDown,
      onClick = props.onClick,
      inner = props.inner,
      children = props.children;

  return _react2.default.createElement(
    'button',
    {
      className: 'ReactA11ySelect__button',
      id: buttonId,
      role: 'button',
      tabIndex: open ? "-1" : "0",
      'aria-haspopup': 'true',
      'aria-expanded': open ? true : undefined // ARIA recommends not including over false
      , 'aria-controls': listId,
      onKeyDown: onKeyDown,
      onClick: onClick
    },
    _react2.default.createElement(
      'span',
      null,
      children
    ),
    _react2.default.createElement('span', { className: 'ReactA11ySelect__button__arrow-indicator', 'aria-hidden': 'true' })
  );
};

SelectButton.propTypes = process.env.NODE_ENV !== "production" ? {
  open: _propTypes2.default.bool,
  buttonId: _propTypes2.default.string,
  listId: _propTypes2.default.string,
  highlightedId: _propTypes2.default.string,
  onKeyDown: _propTypes2.default.func,
  onClick: _propTypes2.default.func
} : {};

exports.default = SelectButton;